import { createGeneratePath } from "@itandi/tools/vanilla";

export const generatePath = createGeneratePath<
	| "/property_deals/:property_deal_id/deal_expected_accounting_dates"
	| "/deals"
	| "/deals/:id"
	| "/deals/:deal_id/deal_todos"
	| "/deals/:deal_id/messages"
	| "deals/:deal_id/related_deals"
	| "/deals/:deal_id/partner_deals"
	| "/deals/:deal_id/past_deals"
	| "/deals/:deal_id/owner_explanation_suggestion"
	| "/deals/:deal_id/owner_explanation_suggestion/executable"
	| "/deals/:deal_id/deal_expected_accounting_date"
	| "/deals/:deal_id/revert_own_status"
	| "admin/deals/:deal_id/revert_status"
	| "/company_vendors"
	| "/staffs"
	| "/staffs/:id"
	| "/staffs/:id/update_enabled"
	| "/staffs/login"
	| "/staffs/logout"
	| "/settings/company_construction_items"
	| "/settings/company_dashboard_settings"
	| "/settings/company_workflow_settings"
	| "/company_workflow_settings"
	| "/company_notifications"
	| "/company_construction_items"
	| "/company_construction_items/update_seq"
	| "/company_construction_items/:id/update_enabled"
	| "/company_dashboard_setting"
	| "/company_store_mails"
	| "/subtypes"
	| "/vendors/vendor_company_password_resets"
	| "/vendors/vendor_user_password_resets"
	| "/vendors/deals"
	| "/vendors/deals/:id"
	| "/vendors/login"
	| "/deal_construction_items"
	| "/vendors/deals/:deal_id/deal_construction_items"
	| "/vendors/deals/:deal_id/deal_estimation_histories"
	| "/vendors/deals/:deal_id/deal_estimation_histories/:id"
	| "/vendors/deals/:deal_id/deal_estimation_histories/update_seq"
	| "/deals/:deal_id/deal_estimation_histories"
	| "/deals/:deal_id/deal_estimation_histories/:id"
	| "/deals/:deal_id/deal_estimation_histories/update_seq"
	| "/deals/:deal_id/deal_own_estimations"
	| "/deals/:deal_id/deal_own_estimations/:id"
	| "/deals/:deal_id/deal_own_estimations/update_seq"
	| "/deals/:deal_id/deal_billings"
	| "/deals/:deal_id/deal_billings/:id"
	| "/deals/:deal_id/deal_billings/bulk_delete"
	| "/deals/:deal_id/deal_billings/update_seq"
	| "/vendors/sessions"
	| "/deals/:deal_id/deal_construction_schedules"
	| "/deals/:deal_id/deal_inspection_report_images"
	| "/deals/:deal_id/deal_completion_report_images"
	| "/vendors/deals/:deal_id/messages"
	| "/vendors/deals/:deal_id/deal_inspection_report_images"
	| "/vendors/deals/:deal_id/deal_inspection_report_completes"
	| "/vendors/deals/:deal_id/deal_completion_report_images"
	| "/vendors/deals/:deal_id/deal_completion_report_completes"
	| "/vendors/deals/:deal_id/deal_estimation_headers/update_note"
	| "/vendors/deals/:id/deal_estimation_histories"
	| "/vendors/deals/:deal_id/deal_construction_schedules"
	| "/vendors/construction_item_settings"
	| "/vendors/line_user_accounts"
	| "/vendors/vendor_users"
	| "/vendors/vendor_users/:id/update_enabled"
	| "/vendors/vendor_partners"
	| "/api/deals/:deal_id/deal_inspection_reports"
	| "/api/deals/:deal_id/deal_completion_reports"
	| "/api/vendors/deals/:deal_id/deal_inspection_reports"
	| "/api/vendors/deals/:deal_id/deal_completion_reports"
	| "/settings/admin/company_ip_addresses"
	| "/invite_vendors/company_vendor_payload"
	| "/admin/company_ip_addresses"
	| "/admin/company_ip_addresses/:id"
	| "/admin/ai_prompts"
	| "/admin/ai_prompts/:id"
	| "/admin/vendor_companies"
	| "/todo_templates"
	| "/vendors/deals/:deal_id/deal_partner_assignment"
	| "/vendors/deals/:deal_id/deal_partner_assignment/latest"
	| "/vendors/deals/:deal_id/deal_partner_assignment/withdraw"
	| "/itandi_account_sessions/current_account"
	| "/api/deals/:deal_id/leasing_inspection_file"
	| "/api/vendors/deals/:deal_id/leasing_inspection_file"
	| "/vendors/kt_leasings/:leasing_id"
	| "/deals/:id/sk_partner_deal"
	| "/deals/:deal_id/deal_estimation_ocr_requests"
	| "/deals/:deal_id/deal_estimation_ocr_requests/:id"
	| "/deals/:deal_id/deal_estimation_ocr_requests/:id/reflection"
	| "/api/deals/:deal_id/deal_billing_estimation_files"
	| "/api/deals/:deal_id/deal_estimation_ocr_requests/:id/file"
	| "/direct_upload_files"
>();
